import { useEffect } from 'react';

export const getHighlightedBudgetId = (
  search: string,
  state: { highlightedBudgetId?: string } | undefined,
) => {
  if (state?.highlightedBudgetId) {
    return state.highlightedBudgetId;
  }
  return new URLSearchParams(search).get('highlightedBudgetId');
};

export const useScrollToHighlightedBudgetId = (
  highlightedBudgetId: string | null,
) => {
  useEffect(() => {
    if (highlightedBudgetId) {
      const element = document.getElementById(`budget-${highlightedBudgetId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [highlightedBudgetId]);
};
